<template>
    <div>
        <div class="faqs-button-slider">
            <faqs-slider
                @ActionOne="show = true"
                @ActionTwo="show = false"
                :show="show"
            ></faqs-slider>
        </div>
        <div class="faqs-grid">
            <transition name="fade">
                <shipping-card v-if="show"></shipping-card>
                <!-- <about-card v-if="!show"></about-card> -->
            </transition>
        </div>
    </div>
</template>
<script>
import ShippingCard from "./ShippingCard.vue";
import AboutCard from "./AboutCard.vue";
import FaqsSlider from "./FaqsSlider.vue";
export default {
    components: { ShippingCard, AboutCard,FaqsSlider },
    data() {
        return {
            show: true
        };
    },
    watch:{
        show(){

        }
    }
};
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.faqs-grid{
    margin: 1rem 0;
    @media (min-width:1024px) {
        margin: 5rem 0;
    }
}
.faqs-button-slider{
    margin-top: 1rem;
    @media (min-width:1024px) {
        margin-top: 5rem;
    }
}
</style>
